import { getSeasonYears } from "@/lib/dormant-season/helpers";
import { isHiringSeasonDormant } from "@/lib/dormant-season/resolve";

const reopensIn = (next: number) => `reopens in early January ${next}`;

export function getMatchStatusDormantNotice(now: Date): string | undefined {
  if (!isHiringSeasonDormant("match-status")) {
    return undefined;
  }

  const { next } = getSeasonYears(now);

  return `Matching is paused for the season and ${reopensIn(next)}.`;
}

export function getMatchStatusDormantTrackerCopy(
  now: Date,
): { title: string; description: string } | undefined {
  if (!isHiringSeasonDormant("match-status")) {
    return undefined;
  }

  const { next } = getSeasonYears(now);

  return {
    title: "Matching is paused for the season",
    description: `You can update your status to "Open to matches" when matching ${reopensIn(next)}. Until then you can keep browsing and applying to jobs.`,
  };
}
